export default function ReadOnlyValue({value}) {
    return value
}